// @ts-check
import React from 'react';
import cx from 'classnames';
// import preferralSearchSrc from './preferral_search.svg';
import aristamdSearchSrc from './aristamd_search.svg';
import styles from './ChooseNetwork.module.scss';

const ChooseNetwork = ({ availableNetworks, selectNetwork }) => {
  const preferralNetwork = availableNetworks.find((n) => n.id === 'preferral');
  const otherNetworks = availableNetworks.filter((n) => n.id !== 'preferral');
  return (
    <div className={styles.outer} data-spec-id="NewReferralTypeModal">
      <div className={styles.modal_head}>
        <h4>Select Where to Refer Patient</h4>
      </div>
      <div className={styles.modal_body}>
        <section className={styles.logos_section}>
          <h4>Search AristaMD Network:</h4>
          <div className={styles.logos}>
            <div
              className={cx(styles.logo_tile, styles.amd_logo_tile)}
              onClick={() => selectNetwork(preferralNetwork.id)}
            >
              <img src={aristamdSearchSrc} alt="AristaMD Logo" />
            </div>
          </div>
          <h4>Or, Choose an Organization to Refer To:</h4>
          <div className={styles.logos}>
            {otherNetworks.map((network) => (
              <div
                data-spec-id={`choose-network-${network.id}`}
                key={network.id}
                className={styles.logo_tile}
                onClick={() => selectNetwork(network.id)}
              >
                {network.logoUrl ? (
                  <img src={network.logoUrl} alt={network.name} />
                ) : (
                  <div style={{ padding: '10px' }}>{network.name} </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default ChooseNetwork;
